import { UnauthorizedErrorName } from '../constants/errorName';

export class UnauthorizedError extends Error {
  constructor(args) {
    super(args);
    this.name = UnauthorizedErrorName;
  }
}
